module.exports = __webpack_public_path__ + "static/img/guide2.8cbb0b5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide2.webp
// module id = 6Zvd
// module chunks = 1